const commonTCTransPath = 'termsAndConditions.';
const tandCTransPath = 'onboard.terms.';
 const translations = {
    PAGE_TC_TITLE: commonTCTransPath + "title",
    TC_CHECKBOX_LABEL: commonTCTransPath + "checkBoxLabel",

    TERMS_DESCRIPTION: tandCTransPath + 'description',
}

export default translations